import script from "./PortfolioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioPage.vue?vue&type=style&index=0&id=38d3b3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d3b3e2"]])

export default __exports__